import * as React from "react";

import "./image-selector.scss";

import {cs}         from "@Common/react/chain-services";
import {chain}      from "@Common/utils/fs";

import {Thumbnails} from "./thumbnails/thumbnails";

export const ImageSelector = ({allowReproof, images, loadingProofs, state, onEnlarge}) => cs(
    () => (
        <div className="image-selector image-selector-57s">
            <div className="body">
                {images?.length > 1 && (
                    <>
                        <div className="header">
                            <div className="title" xd-qa-type="label" xd-qa-name="Available Backs">
                                Available Backs
                            {state.value.changeBackOverride && <>
                                <i {...{
                                    className: "fa fa-check",
                                    onClick: () => {
                                        let newState = state.value;
                                        delete newState.changeBackOverride;
                                        delete newState.itemThumbnails;
                                        state.onChange(newState);
                                        if( allowReproof ) {
                                            loadingProofs.onChange('reproof');
                                        }
                                    },
                                }}
                                    xd-qa-type="icon"
                                    xd-qa-name="Check"
                                />
                                <i {...{
                                    className: "fa fa-close",
                                    onClick: () => {
                                        let newState = state.value;
                                        delete newState.changeBackOverride;
                                        state.onChange(newState);
                                    },
                                }}
                                    xd-qa-type="icon"
                                    xd-qa-name="Close"
                                />
                            </>}
                            </div>
                        </div>
                        {Thumbnails({images})}
                    </>
                )}
                <div className="large" onClick={onEnlarge}>
                    {chain(
                        images?.find((img) => img.selected),
                        (img) => <>
                            <div className="img">
                                <img src={img?.src} alt="selected back"/>
                            </div>
                            <div className="footer">
                                <div className="left">
                                    {img?.details}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    ),
);
